var _polygon, _polygon2, _rect, _polygon3, _polygon4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagesCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-247"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110.22,
    width: 1,
    height: 37.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.93 59.92 132.06 64.03 89.38 64.03 87.52 59.92 105.69 47.35 115.76 47.35 133.93 59.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.02 35.23 115.76 47.35 105.69 47.35 104.43 35.23 117.02 35.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.93 59.93 132.06 64.03 89.38 64.03 87.52 59.93 133.93 59.93",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.08,
    width: 1,
    height: 37.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.78 59.92 224.91 64.03 182.23 64.03 180.37 59.92 198.54 47.35 208.61 47.35 226.78 59.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.87 35.23 208.61 47.35 198.54 47.35 197.28 35.23 209.87 35.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.78 59.93 224.91 64.03 182.23 64.03 180.37 59.93 226.78 59.93",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.93,
    width: 1,
    height: 37.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.63 59.92 317.77 64.03 275.08 64.03 273.22 59.92 291.39 47.35 301.46 47.35 319.63 59.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.72 35.23 301.46 47.35 291.39 47.35 290.13 35.23 302.72 35.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.63 59.93 317.76 64.03 275.08 64.03 273.22 59.93 319.63 59.93",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.78,
    width: 1,
    height: 37.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.49 59.92 410.62 64.03 367.93 64.03 366.07 59.92 384.25 47.35 394.31 47.35 412.49 59.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.57 35.23 394.31 47.35 384.25 47.35 382.98 35.23 395.57 35.23",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.48 59.93 410.62 64.03 367.93 64.03 366.07 59.93 412.48 59.93",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,271.25l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,285.36l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05H45.9v-.44l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,362.6l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.81,376.71l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69,0h-.44v-.44l-.05-11.19V365h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.66,285.36l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.89,86.89l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06H412v-.45l0-11.19v-.5h.51l13.24.06c4.41,0,8.82.12,13.24.17h.27v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.12-3.71-.14-5.54l.28.27c-4.42,0-8.83.16-13.24.17l-13.24.06.5-.5-.06,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.66,101l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45V101l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.27v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.12-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5L427.62,101l-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.59,86.89l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45L60.61,75.7v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.38,210l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69,0h-.45V210l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16l-13.24.07.5-.5L119.34,210l-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-247"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.37 391.89 91.28 391.64 144.18 391.56 250 391.39 355.82 391.55 408.73 391.64 461.63 391.89 408.73 392.13 355.82 392.22 250 392.39 144.18 392.22 91.28 392.13 38.37 391.89",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-247"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 453.6,
    rx: 116.76,
    ry: 15.03,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Images--inject-247"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.84,
    y: 147.6,
    width: 132.14,
    height: 80.92,
    transform: "translate(554.98 -178.85) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.45,254.14,326.27,122v-.19h.18l80.93-.06h.24V122l-.08,132.14v.16h-.16Zm0,0,80.93-.16-.16.16L407.14,122l.24.24-80.93-.06.18-.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.26,
    y: 126.81,
    width: 71.3,
    height: 122.52,
    transform: "translate(733.83 376.13) rotate(180)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.26,
    y: 126.81,
    width: 71.3,
    height: 122.52,
    transform: "translate(733.83 376.13) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,163.49a6.48,6.48,0,1,0,5.09-5.08A6.48,6.48,0,0,0,342,163.49Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.79 205.27 402.57 205.27 378.68 175.83 354.79 205.27",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.79 205.27 402.57 205.27 378.68 175.83 354.79 205.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "331.26 205.27 373.64 205.27 352.45 186.1 331.26 205.27",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.26 205.27 373.64 205.27 352.45 186.1 331.26 205.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 331.26,
    y: 205.27,
    width: 71.3,
    height: 44.05,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.26,
    y: 205.27,
    width: 71.3,
    height: 44.05,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "326.45 122 336.52 118.75 346.6 115.59 366.81 109.38 366.92 109.34 367.02 109.38 387.23 115.59 397.31 118.76 407.38 122 397.21 119.11 387.06 116.14 366.81 110.09 367.02 110.09 346.77 116.14 336.62 119.11 326.45 122",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.92,
    cy: 109.74,
    r: 1.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.86,
    y: 61.94,
    width: 74.18,
    height: 110.47,
    transform: "translate(368.12 -133.78) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.43,154.51h-111V79.84h111ZM196,154h110V80.34H196Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 84.9,
    width: 100.84,
    height: 64.55,
    transform: "translate(501.9 234.35) rotate(180)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.3,101.28a6.48,6.48,0,1,0,5.09-5.09A6.49,6.49,0,0,0,210.3,101.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 137.66 301.37 137.66 267.59 96.02 233.8 137.66",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "233.8 137.66 301.37 137.66 267.59 96.02 233.8 137.66"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "200.53 137.66 260.46 137.66 230.49 110.55 200.53 137.66",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "200.53 137.66 260.46 137.66 230.49 110.55 200.53 137.66"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 137.66,
    width: 100.84,
    height: 11.79,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 200.53,
    y: 137.66,
    width: 100.84,
    height: 11.79
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "195.72 80.08 209.49 76.84 223.27 73.67 250.87 67.46 250.95 67.44 251.03 67.46 278.63 73.67 292.42 76.84 306.18 80.08 292.34 77.2 278.51 74.24 250.87 68.19 251.03 68.19 223.4 74.24 209.57 77.2 195.72 80.08",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56,67.83A1.61,1.61,0,1,1,251,66.21,1.61,1.61,0,0,1,252.56,67.83Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.56,
    y: 234.12,
    width: 74.18,
    height: 140.01,
    transform: "translate(554.77 53.48) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.9,341.46H180.39V266.79H320.9Zm-140-.5H320.4V267.29H180.89Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.45,
    y: 271.85,
    width: 130.39,
    height: 64.55,
    transform: "translate(501.29 608.25) rotate(180)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.74,288.23a6.48,6.48,0,1,0,5.09-5.08A6.48,6.48,0,0,0,196.74,288.23Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.47 324.62 315.84 324.62 272.15 282.98 228.47 324.62",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "228.47 324.62 315.84 324.62 272.15 282.98 228.47 324.62"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "185.45 324.62 262.94 324.62 224.19 297.5 185.45 324.62",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "185.45 324.62 262.94 324.62 224.19 297.5 185.45 324.62"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 185.45,
    y: 324.62,
    width: 130.39,
    height: 11.79,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 185.45,
    y: 324.62,
    width: 130.39,
    height: 11.79
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "180.64 267.04 198.11 263.79 215.59 260.63 250.58 254.41 250.65 254.4 250.71 254.41 285.7 260.63 303.18 263.79 320.65 267.04 303.12 264.15 285.6 261.19 250.58 255.15 250.71 255.15 215.69 261.19 198.18 264.15 180.64 267.04",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.26,254.78a1.62,1.62,0,1,1-1.61-1.61A1.61,1.61,0,0,1,252.26,254.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 272.37,
    width: 43.65,
    height: 45.31,
    transform: "translate(657.55 -67.5) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.43,317.1H339.62V273h45.81Zm-45.31-.5h44.81V273.45H340.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 276.03,
    width: 39.65,
    height: 37.99,
    transform: "translate(725.05 590.05) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,285.67a3.82,3.82,0,0,0,4.49,4.48,3.81,3.81,0,1,0-4.49-4.48Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.78 307.08 382.35 307.08 369.07 290.71 355.78 307.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.7 307.08 366.26 307.08 354.48 296.42 342.7 307.08",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 307.08,
    width: 39.65,
    height: 6.94,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.87,273.2c3.73-1.35,7.48-2.62,11.24-3.88,1.88-.65,3.77-1.24,5.65-1.86l5.65-1.83.12,0,.11,0,5.65,1.83c1.89.62,3.78,1.21,5.65,1.86,3.76,1.26,7.51,2.53,11.24,3.88-3.82-1.06-7.62-2.19-11.41-3.33-1.9-.56-3.79-1.17-5.68-1.76l-5.68-1.77h.23L357,268.11c-1.9.59-3.78,1.2-5.68,1.76C347.49,271,343.69,272.14,339.87,273.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.53,
    cy: 265.99,
    r: 1.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.9,
    y: 260.46,
    width: 92.88,
    height: 55.16,
    transform: "translate(429.38 146.7) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.17,334.73H113.51V241.35h55.66Zm-55.16-.5h54.66V241.85H114Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.59,
    y: 244.43,
    width: 49.5,
    height: 87.22,
    transform: "translate(282.68 576.08) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.34,276a3.82,3.82,0,0,0,4.49,4.48,3.78,3.78,0,0,0,3-3,3.81,3.81,0,1,0-7.48-1.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.89 303.8 165.99 303.8 149.44 283.4 132.89 303.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.59 303.8 145.94 303.8 131.27 290.51 116.59 303.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.59,
    y: 303.8,
    width: 49.5,
    height: 27.85,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76,241.6c4.56-1.36,9.14-2.63,13.72-3.89,2.28-.64,4.59-1.24,6.88-1.85l6.89-1.84.09,0,.1,0,6.88,1.84c2.3.61,4.6,1.21,6.88,1.85,4.58,1.26,9.16,2.53,13.72,3.89-4.64-1.06-9.25-2.19-13.86-3.33-2.31-.56-4.61-1.17-6.91-1.75l-6.9-1.78h.18l-6.9,1.78c-2.3.58-4.6,1.19-6.91,1.75C123,239.41,118.4,240.54,113.76,241.6Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.34,
    cy: 234.38,
    r: 1.61,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.25,
    y: 132.54,
    width: 93.68,
    height: 80.92,
    transform: "translate(306.09 39.92) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,219.84l-.17-93.67V126h.17l80.93-.07h.25v.25l-.09,93.67V220h-.16Zm0,0,80.93-.16-.16.16-.09-93.67.25.24-80.93-.07.17-.17Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.43,
    y: 130.98,
    width: 71.3,
    height: 84.05,
    transform: "translate(266.17 346.01) rotate(180)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.43,
    y: 130.98,
    width: 71.3,
    height: 84.05,
    transform: "translate(266.17 346.01) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.53,155.28a6.48,6.48,0,1,0,5.08-5.08A6.48,6.48,0,0,0,104.53,155.28Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.96 186.24 168.74 186.24 144.85 156.8 120.96 186.24",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.96 186.24 168.74 186.24 144.85 156.8 120.96 186.24",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 186.27 139.8 186.27 118.62 167.09 97.43 186.27",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "97.43 186.27 139.8 186.27 118.62 167.09 97.43 186.27",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.43,
    y: 186.24,
    width: 71.3,
    height: 28.79,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.43,
    y: 186.24,
    width: 71.3,
    height: 28.79,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "92.62 126.17 102.68 122.88 112.77 119.67 132.97 113.37 133.08 113.33 133.19 113.37 153.4 119.67 163.49 122.88 173.55 126.17 163.38 123.23 153.23 120.22 132.97 114.08 133.19 114.08 112.94 120.22 102.79 123.23 92.62 126.17",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,113.73a1.62,1.62,0,1,1-1.62-1.62A1.61,1.61,0,0,1,134.7,113.73Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-247"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 219.34,
    y: 169.25,
    width: 65.33,
    height: 82.18,
    transform: "translate(476.49 -29.14) rotate(93.3)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.38,245.58h-.25l-82.3-4.75,0-.24,3.77-65.48.25,0,82.3,4.74,0,.25Zm-82-5.23,81.55,4.7,3.73-64.72-81.55-4.7Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.79,
    y: 182.56,
    width: 72.41,
    height: 55.56,
    transform: "translate(491.48 434.83) rotate(-176.7)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,193.07a6.58,6.58,0,1,0,5.45-4.86A6.58,6.58,0,0,0,224,193.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.79 225.42 287.24 228.21 264.74 196.96 238.79 225.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.94 224.07 257.9 226.54 237.54 205.87 214.94 224.07",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.54,
    y: 226.12,
    width: 72.41,
    height: 11.97,
    transform: "translate(13.77 -14.04) rotate(3.3)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.86 175.37 222.6 172.66 232.36 170.02 242.13 167.43 251.91 164.87 252.02 164.84 252.12 164.88 273.55 172.39 284.24 176.21 294.9 180.1 284.12 176.55 273.36 172.93 251.88 165.58 252.09 165.59 242.3 168.09 232.5 170.58 222.69 173.01 212.86 175.37",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.64,165.23a1.64,1.64,0,1,1-1.64-1.64A1.65,1.65,0,0,1,253.64,165.23Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.48,395.83s-1,39.62-1,39.64c0,7.33.18,13.75.57,17.06a0,0,0,0,0,0,.05,5.23,5.23,0,0,0,.55,2.26l0,.05c2.19,1.47,60.71,3,62.77,2.35s.41-6.55-1.82-8.42-24.37-12.47-24.37-12.47l.64-39.6Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.41,427.61s.06,7.84.06,7.86c0,7.33.18,13.75.57,17.06a0,0,0,0,0,0,.05,9.74,9.74,0,0,0,.55,2.26l0,.05c2.19,1.47,60.71,3,62.77,2.35s.41-6.55-1.82-8.42-24.37-12.47-24.37-12.47l0-8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,436.37c-3.9-.64-8.63.05-11.54,2.88-.11.11.05.27.17.23a54.7,54.7,0,0,1,11.37-2.62A.25.25,0,0,0,196.79,436.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.63,438c-3.9-.64-8.63.05-11.54,2.88-.11.11,0,.27.17.23a54.41,54.41,0,0,1,11.37-2.62A.25.25,0,0,0,199.63,438Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.47,439.63c-3.9-.65-8.63.05-11.54,2.88-.11.11,0,.27.17.23a54.46,54.46,0,0,1,11.36-2.62A.25.25,0,0,0,202.47,439.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,457.24c-2.07.64-60.58-.88-62.77-2.35-.84-.55-1.12-9.09-1.15-19.41v-.33l37.76.56,0,.64s22.14,10.6,24.37,12.47S221.46,456.62,219.4,457.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47,435.15v.33c.05,10.32.31,18.86,1.16,19.41s13.67,1.35,27.38,1.84c16.4.58,34.26.86,35.39.52,2.06-.64.4-6.56-1.82-8.43s-24.37-12.47-24.37-12.47l0-.64-12.59-.19Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,455c-9.85-.5-49.66-1.58-59.44-1.32-.08,0-.08.05,0,.06,9.76.71,49.57,1.46,59.44,1.42C219,455.12,219,455,218.79,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.65,435.52c.92,6.33,2.33,15.65,3.36,21.21,16.4.58,34.26.86,35.39.52,2.06-.64.4-6.56-1.82-8.43s-24.37-12.47-24.37-12.47l0-.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07,435.69l42.35.4s2.4-68.94,2.58-91.94c.21-26.26-1.28-105-1.28-105H164.06s-8.5,17.36-3.64,36.9l1.34,70.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.21,428.28a31.45,31.45,0,0,1,3.37-.27c1.25-.09,2.5-.18,3.75-.24,2.41-.1,4.82-.14,7.23-.15,4.86,0,9.73,0,14.59.17,2.76.09,5.53.2,8.29.35a.09.09,0,0,1,0,.18c-4.82.17-9.65.25-14.47.34s-9.64.19-14.46.1c-1.38,0-2.76,0-4.14-.12s-2.79,0-4.14-.2C155.15,428.43,155.11,428.29,155.21,428.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.37,390.22c.49-11.4.85-22.81,1.17-34.22q.93-34.22.49-68.46c-.16-12.8-.5-25.6-.89-38.4,0-.15.22-.14.23,0,1.21,22.92,1.67,45.87,1.7,68.82s-.45,45.65-1.58,68.45c-.63,12.79-1.41,25.59-2.61,38.35a.09.09,0,0,1-.18,0C190.22,413.24,190.87,401.73,191.37,390.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.78,402.13s.32,38.29.32,38.31c0,7.32.17,13.74.56,17.06a.11.11,0,0,0,0,.05,4.94,4.94,0,0,0,.55,2.26.1.1,0,0,0,0,.05c2.18,1.47,60.7,3,62.76,2.35s.41-6.55-1.81-8.42-24.38-12.48-24.38-12.48l-.68-38.26Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,432.58s.07,7.84.07,7.86c0,7.32.17,13.74.56,17.06a.11.11,0,0,0,0,.05,9.9,9.9,0,0,0,.55,2.26.1.1,0,0,0,0,.05c2.18,1.47,60.7,3,62.76,2.35s.41-6.55-1.81-8.42-24.38-12.48-24.38-12.48l0-8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,441.34c-3.9-.65-8.63.05-11.54,2.88-.11.11,0,.27.17.23a54.46,54.46,0,0,1,11.36-2.62A.25.25,0,0,0,243.42,441.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.26,443c-3.9-.65-8.64,0-11.54,2.88-.12.11,0,.27.17.22a55.08,55.08,0,0,1,11.36-2.61A.25.25,0,0,0,246.26,443Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09,444.59c-3.89-.64-8.63.06-11.54,2.89-.11.11,0,.27.17.22a55.35,55.35,0,0,1,11.37-2.62A.25.25,0,0,0,249.09,444.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,462.21c-2.06.64-60.57-.88-62.76-2.36-.85-.54-1.12-9.08-1.16-19.41v-.32l37.77.56,0,.64s22.14,10.6,24.38,12.47S268.08,461.58,266,462.21Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.42,459.93c-9.86-.5-49.66-1.58-59.45-1.33-.08,0-.08.06,0,.07,9.76.7,49.58,1.46,59.45,1.42C265.62,460.09,265.63,459.94,265.42,459.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.43,279.64s17.37,54.75,17.68,64.82c.27,8.58-.83,96.61-.83,96.61l44,.27s-3.71-89.78-4.4-98.73c-1.28-16.71-15.93-62.61-26.4-103.5H165s.42,21.41,10.15,36.9C175.19,276,179.6,278.05,182.43,279.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.62,433c5.08-.15,10.35-.3,15.43-.17s10.09.2,15.13.5c2.85.17,5.7.26,8.55.55a.08.08,0,0,1,0,.15c-5.07.3-10.17.24-15.25.19s-10.09-.1-15.13-.33c-2.86-.13-5.7-.28-8.56-.47C201.48,433.36,201.31,433,201.62,433Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,264.91c1.56,5.23,17,60.34,19.06,70.8s4.72,78.85,4.53,89.81c0,1.37-.05,2.73-.1,4.09a.11.11,0,0,1-.21,0c-.29-10.91-3.2-82.7-5.07-93.39-1.84-10.5-17.18-65.27-18.53-71.23A.17.17,0,0,1,211.24,264.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.3,280.7a38.68,38.68,0,0,1-6.53-.6,62.91,62.91,0,0,1-6.32-1.75,49.91,49.91,0,0,0-6.21-1,21.88,21.88,0,0,1-6.08-1.82.08.08,0,0,0-.07.14,37.52,37.52,0,0,0,5.82,2.53c2.09.66,4.27.75,6.39,1.26a51.61,51.61,0,0,0,6.51,1.5,23.35,23.35,0,0,0,6.52-.11C193.41,280.83,193.38,280.7,193.3,280.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,324.25c-.42-1.62-.81-3.25-1.25-4.86-.89-3.27-1.79-6.54-2.78-9.78-2-6.44-3.82-12.92-5.89-19.33-1.18-3.63-2.24-7.31-3.62-10.87a.07.07,0,0,0-.14,0c.69,3.32,1.68,6.57,2.56,9.85s1.82,6.53,2.76,9.78c1.88,6.47,3.72,12.95,5.76,19.37.58,1.8,1.17,3.59,1.79,5.37s1.13,3.71,1.89,5.48a.08.08,0,0,0,.16-.05C197,327.56,196.5,325.91,196.08,324.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.39,186.94c-3.21,0-7.86-6.47-9-10.73-.08-.29,1-2.91,2.11-6.15.68-2,1.39-4.18,1.9-6.24l12.17,6.3a34.06,34.06,0,0,0-3.19,7.62,4.54,4.54,0,0,0-.12.87.76.76,0,0,1,0,.14C203.13,180.42,202.49,187,199.39,186.94Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.27,178.6a.81.81,0,0,1,0,.15,8.1,8.1,0,0,1-1.35-.25c-7.54-2.17-7.45-11.18-7.15-14.49l11.82,6.12a33.88,33.88,0,0,0-3.19,7.61A5.54,5.54,0,0,0,203.27,178.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.13,148.62c-2.13,4.5-1.64,18.47,1.27,22,4.21,5.11,12.1,6.7,16.69,1.41,4.45-5.13,3.48-23.32.15-26.63C207.32,140.53,197.27,142,194.13,148.62Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.73,153.11s.93,5.26,1.88,10.49l-1.76-.28.33,2.37a4.68,4.68,0,0,1-3.67-.87Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,158.72s-.07.05-.06.09c.1.93,0,2-.78,2.4,0,0,0,.06,0,0C212.85,161,212.9,159.59,212.65,158.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.74,157.8c-1.52,0-1.41,3,0,3S213,157.8,211.74,157.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.49,156.67c.41-.12.76-.3,1.16-.46a2,2,0,0,0,1.09-.69.61.61,0,0,0-.13-.77,1.57,1.57,0,0,0-1.61-.11,2.3,2.3,0,0,0-1.31,1.06A.69.69,0,0,0,210.49,156.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.53,167.53c.23.21.47.51.81.52a2.33,2.33,0,0,0,1-.27,0,0,0,0,1,0,.05,1.28,1.28,0,0,1-1.18.55,1,1,0,0,1-.77-.81S211.5,167.5,211.53,167.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.23,164.64a3.14,3.14,0,0,0,3.23,1.15c.07,0,.1-.08.08-.08a5.78,5.78,0,0,1-3.27-1.18C211.19,164.48,211.17,164.57,211.23,164.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.56,142.72c1.36,3.13-.39,9-9.58,7.58a8.38,8.38,0,0,1,0,4.57,2.24,2.24,0,0,1-1.71,1.53,13.45,13.45,0,0,1,.26,3.65,1.48,1.48,0,0,1-1.42.33s-6.85,7.2-9.3,6.3c-1-3.1-6.13-12.79-3.15-18.88,1.54-3.14,5.83-4.15,5.83-4.15C205,136.69,213.38,137.71,215.56,142.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,150.3a13,13,0,0,1,.48,3.71,2.58,2.58,0,0,1-.6,1.62,3.18,3.18,0,0,1-1.64.77,2.3,2.3,0,0,0,2.72-2.35,5.61,5.61,0,0,0-.22-2A7,7,0,0,0,206,150.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.44,143.65a9.27,9.27,0,0,0-5.24,2.1,6.43,6.43,0,0,0-1.7,2.36,9.24,9.24,0,0,0-.6,2.83,17.49,17.49,0,0,0,.76,5.67,24.55,24.55,0,0,0,2.2,5.23,35,35,0,0,1-1.84-5.33,18.3,18.3,0,0,1-.63-5.54,8.8,8.8,0,0,1,.52-2.7,6.47,6.47,0,0,1,1.54-2.24A10,10,0,0,1,196.44,143.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.06,160.38s-2.52-4.8-4.66-3.95-.63,7.53,1.61,8.7a2.4,2.4,0,0,0,3.36-.88Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,158.33a0,0,0,0,0,0,.07,6.08,6.08,0,0,1,2.64,4.17,1.33,1.33,0,0,0-1.93-.61.05.05,0,0,0,0,.09,1.48,1.48,0,0,1,1.55.72,7.07,7.07,0,0,1,.61,1.41c.06.15.33.11.3-.07v0C202.37,162,201.11,158.83,198.88,158.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.27,247s56.06,5.94,56.67,5.36c.85-.81-2.55-57.92-11.23-71.46-2.19-3.42-12.43-7.17-15.23-4.83C168.05,194,158.88,246.36,159.27,247Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,238.86l-.86.35c-4.83,2-9.37,4.66-14.24,6.67a33.07,33.07,0,0,1-7.56,2.25A21.31,21.31,0,0,1,185,248c-.64-.17-1.29-.32-1.92-.51s-1.25-.44-1.86-.69a14.71,14.71,0,0,1-3.41-2,17.54,17.54,0,0,1-4.77-6.26c-.06-.12-.11-.23-.16-.35s-.11-.24-.16-.36a36.1,36.1,0,0,1-2.15-6.78c-.58-2.56-1-5.16-1.31-7.76-.46-3.51-.78-7-1.21-10.52,0,0,0-.05,0-.08a2.31,2.31,0,0,1,.1-.28,3,3,0,0,1,.11-.32c0,.2.05.4.07.6s.06.43.08.65c.41,3.3.73,6.62,1.16,9.91.34,2.59.75,5.18,1.33,7.73a36.19,36.19,0,0,0,2.22,6.89c0,.12.11.24.17.36a1.11,1.11,0,0,0,.07.16,17.22,17.22,0,0,0,4.69,6.13,17,17,0,0,0,7,3.14,21,21,0,0,0,7.74.13,33.29,33.29,0,0,0,7.47-2.24c4.83-2,9.38-4.64,14.24-6.64l1-.4C215.49,238.6,215.5,238.73,215.51,238.86Zm-.94-11.15c-2.83,1.39-5.62,2.83-8.52,4a37,37,0,0,1-7.46,2.3,22.48,22.48,0,0,1-7.76.1l-.58-.11-.64-.13a23.37,23.37,0,0,1-12.26-7.05,36.76,36.76,0,0,1-4.53-6.37c-1.33-2.26-2.54-4.58-3.9-6.83-.21-.34-.41-.67-.63-1l-.18-.28a2.31,2.31,0,0,0-.1.28.05.05,0,0,0,0,0l0,0c.12.19.24.38.35.57s.21.33.31.5c1.35,2.24,2.56,4.57,3.88,6.84a37.07,37.07,0,0,0,4.56,6.43,22.3,22.3,0,0,0,2.89,2.69l.39.31.4.29.81.56.85.52.42.25.44.23a25,25,0,0,0,5.78,2.22l.62.14,1.05.21a22.67,22.67,0,0,0,7.88-.08,37.35,37.35,0,0,0,7.54-2.31c2.88-1.18,5.64-2.59,8.42-4C214.59,228,214.58,227.86,214.57,227.71Zm-.16-1.58a21.64,21.64,0,0,0-6,.16,33.22,33.22,0,0,0-7.56,2.25c-3.86,1.6-7.51,3.6-11.28,5.36l-.51.23c-.81.38-1.62.74-2.45,1.08a36.15,36.15,0,0,1-7.46,2.29,22.38,22.38,0,0,1-6.11.32l-.39,0c-.42-.05-.84-.1-1.26-.17a24.1,24.1,0,0,1-9.6-3.9c0,.12-.05.23-.08.34l.47.33.84.52.43.25.43.23a24.64,24.64,0,0,0,7.46,2.57c.49.08,1,.14,1.47.19l.4,0a22.87,22.87,0,0,0,6-.32,36.7,36.7,0,0,0,7.54-2.3c1-.41,2-.84,2.92-1.29l.53-.24c3.62-1.7,7.13-3.6,10.8-5.11a33.29,33.29,0,0,1,7.47-2.24,21.43,21.43,0,0,1,5.93-.16C214.43,226.39,214.42,226.26,214.41,226.13Zm-8.23-42.41a31.15,31.15,0,0,1-3.85-5s0,0,0,0v0l-.31-.21-.21-.12.24.37c.11.19.24.38.36.56a30.65,30.65,0,0,0,3.75,4.74l.31.31Zm4.38,15.49a10.86,10.86,0,0,1-1.62-1.24,16.56,16.56,0,0,1-4-6.59,44.87,44.87,0,0,1-1.87-7.6c-.25-1.48-.46-3-.64-4.46,0-.2,0-.4-.08-.6l-.31-.21,0,.25c.21,1.69.44,3.39.73,5.07a44,44,0,0,0,1.9,7.64,16.86,16.86,0,0,0,4.12,6.68,11.39,11.39,0,0,0,1.84,1.39Zm.74,3.92c-1.06.38-2.12.74-3.19,1.06a31.53,31.53,0,0,1-3.83.84,23.08,23.08,0,0,1-3.9.22,20.23,20.23,0,0,1-3.87-.52c-.64-.12-1.25-.34-1.88-.51s-1.23-.44-1.84-.68a11.32,11.32,0,0,1-3.25-2.1,16.67,16.67,0,0,1-4-6.59,44,44,0,0,1-1.88-7.6c-.24-1.44-.44-2.88-.61-4.33l-.26.34c.18,1.34.37,2.69.6,4a45.75,45.75,0,0,0,1.9,7.65,16.93,16.93,0,0,0,4.12,6.68,11.73,11.73,0,0,0,3.32,2.14c.62.24,1.23.47,1.86.68s1.25.39,1.9.51a20.64,20.64,0,0,0,3.92.52,23.51,23.51,0,0,0,3.93-.24,32,32,0,0,0,3.85-.87c1.07-.32,2.12-.69,3.17-1.08A.4.4,0,0,1,211.3,203.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,192.46c7.22,14.32,20.06,35.27,29.09,38.14,4.61,1.46,28.28-6.07,35.55-9.29,3.08-1.36-7.83-23.85-11.17-22.51-3.71,1.49-17.35,6.26-20,6.74-1.52.28-13.38-12.25-24-21.43C195,173.32,192.14,180.82,198,192.46Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.89,199.84s7.18-6.66,12.08-10.79c2.73-2.3,7.77-5.83,10.55-6.61,4.16-1.16,22.31-3.34,22.93,1,.57,4-15.26,3.88-15.26,3.88s16-1.31,15.78,3.59-18.06,2.42-18.06,2.42,16.45-1,15.44,4c-.76,3.8-17.07,2.46-17.07,2.46s14.15-.75,13.53,3.19c-.67,4.36-15.81,4.06-15.81,4.06-3.24,9.76-8.78,13.08-13,15C260,222.56,249.89,199.84,249.89,199.84Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,187.46c1.87-.23,3.76-.46,5.64-.52s3.78,0,5.66.08a31.65,31.65,0,0,1,7.27,1.17c-4.29-.88-11-.79-12.93-.73s-3.76,0-5.64.07A0,0,0,1,1,274.64,187.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.71,194.26c2.4-.18,4.78-.44,7.19-.52s5.76-.06,8.16,0c.19,0,.25.28.07.28-2.4,0-5.83.15-8.23.18s-4.8,0-7.19.09C274.67,194.32,274.67,194.27,274.71,194.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.72,200.12a53.79,53.79,0,0,1,11.06,0c.18,0,.08.13-.1.12-3.68-.08-6.56-.18-10.94,0C273.67,200.25,273.65,200.13,273.72,200.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,202.59c-1.6.71-3.22,1.33-4.86,1.93-.82.31-1.64.58-2.48.85q-.62.19-1.26.36a6.18,6.18,0,0,1-.68.16,1.3,1.3,0,0,1-.83-.17,24.29,24.29,0,0,1-4.12-3.35c-1.25-1.21-2.47-2.45-3.62-3.78,1.36,1.1,2.68,2.24,4,3.35.67.54,1.33,1.12,2,1.65a16.51,16.51,0,0,0,2,1.46.74.74,0,0,0,.21.09l.07,0,.13,0c.17,0,.4-.08.6-.12l1.24-.34,2.5-.72C237.59,203.49,239.26,203,241,202.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.51,213.83l18-16.54S212.71,185,203.76,179.84s-10.85.8-7.64,10.3S206.51,213.83,206.51,213.83Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.64,190.61a23.57,23.57,0,0,1-5.14-1.92l-.88-.45c-.29-.16-.57-.34-.85-.5-.57-.33-1.1-.72-1.65-1.09a23.64,23.64,0,0,1-3-2.59,30.65,30.65,0,0,1-3.75-4.74l-.19-.29a.6.6,0,0,1,.16.08,1.91,1.91,0,0,1,.32.16,30.07,30.07,0,0,0,3.65,4.61,23.23,23.23,0,0,0,2.94,2.57c.54.36,1.06.76,1.63,1.08.28.16.55.34.84.5l.87.45a24.5,24.5,0,0,0,4.67,1.8Zm-1.36,10.74-.22,0-.15,0c-.64-.12-1.26-.34-1.89-.52s-1.23-.44-1.83-.67a11.29,11.29,0,0,1-3.25-2.11,16.56,16.56,0,0,1-4-6.59,44.87,44.87,0,0,1-1.87-7.6c-.25-1.48-.46-3-.64-4.46l0-.21a.6.6,0,0,0-.16-.08l-.14-.07c.2,1.63.42,3.25.7,4.87a44,44,0,0,0,1.9,7.64,16.86,16.86,0,0,0,4.12,6.68,11.31,11.31,0,0,0,3.32,2.14c.61.24,1.23.47,1.85.68s1.15.35,1.74.47l.17,0h0a19,19,0,0,0,3.52.49l.22-.21A20,20,0,0,1,216.28,201.35Zm2.91-1.18c-1.06.35-2.1.73-3.13,1.13l-.37.14c-1.29.5-2.57,1-3.86,1.49s-2.47.89-3.72,1.26a31.53,31.53,0,0,1-3.83.84c-.63.08-1.28.15-1.92.19l.1.2c.62,0,1.24-.11,1.85-.19a32,32,0,0,0,3.85-.87c1.26-.38,2.49-.82,3.72-1.28s2.69-1.07,4-1.59l.37-.14c1-.38,1.95-.75,2.94-1.08a29.44,29.44,0,0,1,3-.87l.12-.11A30.76,30.76,0,0,0,219.19,200.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.63,194.89a154.84,154.84,0,0,0-15.19,14.19s.08.15.11.12c4.37-3.62,12.53-11.48,15.24-14.13C220.84,195,220.69,194.85,220.63,194.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.77,211.76c-.68.77-1.4,1.5-2.1,2.25l-.21.23-.17-.3a97.16,97.16,0,0,1-4.88-9.53c-.74-1.62-1.42-3.28-2.06-4.94s-1.19-3.38-1.67-5.1c.8,1.6,1.57,3.21,2.34,4.81l2.27,4.83c1.51,3.22,3,6.45,4.43,9.71l-.38-.07C207.15,213,207.94,212.36,208.77,211.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.93,202.18a14.69,14.69,0,0,1-3.18-4.36,12.7,12.7,0,0,1,1.79,2A13.66,13.66,0,0,1,200.93,202.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.84,298.12a37,37,0,0,1-.72,14.22,39.3,39.3,0,0,1-2.18,6.29c-1.13,2.6-2.32,5.15-2,8,.27.19-.67.16-.7-.12-7.61-4.33-17.37-5.13-23.23-12.21a24.3,24.3,0,0,1-4.83-11.86,36.14,36.14,0,0,1,.27-14.32c1-3.86,3.26-7.59,6.89-9.48s8.65-1.78,12.59-.56C413.41,280.71,417.63,289.89,418.84,298.12Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.74,354.45q-1.55-5.19-3.14-10.37c-2.09-6.77-4.26-13.51-6.66-20.17q-2.16-6-4.56-11.85a73.38,73.38,0,0,1,.91-7.35c.64-3,1.56-5.81,2.42-8.69.06-.18-.23-.27-.3-.1-1.71,4-3.94,9.06-4,13.77-1.86-4.42-3.84-8.79-6-13.09a56.07,56.07,0,0,1,.34-10.9.13.13,0,0,0-.26-.05,39.09,39.09,0,0,0-.75,9.62c-1.63-3.23-3.35-6.42-5.19-9.56-.16-.28-.55,0-.41.29,2.86,5.5,5.51,11.13,8,16.82a36.79,36.79,0,0,0-11.93-6.91c-.19-.06-.33.21-.14.29A43.58,43.58,0,0,1,404,304.74q2.69,6.27,5.11,12.62c-4.76-4.67-11.28-7.74-17.58-9.39-.21-.05-.27.28-.06.34,7.29,2.19,13,6.33,18.5,11.3q1,2.56,1.9,5.15,3.53,9.78,6.72,19.68,1.53,4.74,3,9.5c1.06,3.42,1.89,7,3.28,10.31.13.32.7.25.62-.13A96.74,96.74,0,0,0,422.74,354.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.12,291.45a19,19,0,0,0-2.74,6.84c0,.06.09.1.11,0a58.83,58.83,0,0,1,3-6.7C410.57,291.4,410.25,291.26,410.12,291.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.54,307.31a20.14,20.14,0,0,0-6.83-2.3.06.06,0,0,0,0,.11c1.1.46,2.25.77,3.36,1.2s2.2.95,3.33,1.34A.19.19,0,1,0,396.54,307.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.72,288.24a13.18,13.18,0,0,0-2.2-1.36.11.11,0,0,0-.12.19,13.16,13.16,0,0,0,2.16,1.41C392.7,288.56,392.86,288.33,392.72,288.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.49,324c-5.48,1.63-11,3.14-16.47,4.74-.47.15-9.74-17.61-6.39-26.76a29.85,29.85,0,0,1,18.63-17.67c3.91-1.33,8.73-2.45,12.86-1.54,3.68.82,6.27,3.82,7.47,7.28,1.62,4.7,1.08,10.31.2,15.1a26.43,26.43,0,0,1-5.4,12.33C452.48,320.9,448.77,322.7,444.49,324Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.44,307.09a73.6,73.6,0,0,1-10.75,4.23,45.28,45.28,0,0,0-7.17,2.6c2.31-5.16,4.85-10.22,7.55-15.22a24.65,24.65,0,0,0,9.94-5.13.15.15,0,0,0-.2-.23,50.47,50.47,0,0,1-9.38,4.7q1.1-2,2.22-4c.21-.37-.31-.74-.56-.38a116.56,116.56,0,0,0-7.79,13.08,59.94,59.94,0,0,1-.56-12,.08.08,0,0,0-.16,0,39.61,39.61,0,0,0,.14,13.17c-1.93,3.84-3.68,7.77-5.25,11.75-.63-2.39-1.44-4.75-2-7.16a32.84,32.84,0,0,1-.79-10.55c0-.1-.14-.11-.16,0a37.28,37.28,0,0,0,2.3,19.37c-.91,2.4-1.79,4.8-2.59,7.21a143.8,143.8,0,0,0-7.27,38,.23.23,0,0,0,.46,0A188.62,188.62,0,0,1,428.61,329c1.59-4.78,3.42-9.42,5.42-14,3.24-1,6.47-2.26,9.65-3.36a30.08,30.08,0,0,0,8.88-4.35C452.67,307.2,452.55,307,452.44,307.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.55,301.93c-3.35,1.19-6.53,2.86-9.88,4.07-.15.06-.06.31.1.27,3.54-.73,7.05-1.82,9.91-4.15C457.79,302,457.67,301.89,457.55,301.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.18,294.7c0-.18-.22-.28-.27-.1-.92,3.09-1.56,6.37-.66,9.53,0,.12.23.13.23,0C429.64,300.93,429.47,297.84,430.18,294.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,287.56a8.17,8.17,0,0,0-1.45,5.26c0,.11.19.18.22,0,.41-1.76,1.09-3.38,1.63-5.09A.23.23,0,0,0,444,287.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.3,331.8c1.6,5.1,5.42,12.15,11.47,12.2,3.92,0,7.87-.43,11.8-.48,4.2-.07,8.42-.06,12.62.19.34,0-.5-12.6-10.62-18.74-2.83-1.72-6.3-2.27-9.51-3a43.88,43.88,0,0,0-11.24-1.17c-2.32.09-4.25.58-5.08,3S378.53,329.37,379.3,331.8Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.65,325.41c2.45.64,4.93,1.36,7.4,2.15a24,24,0,0,0-2-2c-1.06-.88-2.22-1.59-3.36-2.36-.09-.06,0-.24.09-.2a13.89,13.89,0,0,1,6,4.75c3.07,1,6.12,2.09,9.05,3.29a33.5,33.5,0,0,1,5.79,3.05,23.13,23.13,0,0,0-2.09-3.65c-1.35-1.74-3.16-2.71-4.92-3.94a.16.16,0,0,1,.16-.27,14.37,14.37,0,0,1,7.89,8.55,33.8,33.8,0,0,1,5.73,5.21c6.69,7.6,12,17.71,12,28,0,.25-.39.32-.44.06a57.26,57.26,0,0,0-12.76-27.41c-.48-.56-1-1.09-1.47-1.6a46.3,46.3,0,0,0-5.53-.42c-2.15,0-4.29.32-6.43.5-3.53.28-7.44.32-10.62-1.45-.14-.08-.05-.32.11-.27,7.1,2.58,14.55-.69,21.66.85a33.14,33.14,0,0,0-10.49-6.77l-.65-.26c-4.56.55-9.37,1.73-13.81.25a.11.11,0,0,1,.06-.21c4.29,1.07,8.4-.27,12.63-.49-4.61-1.79-9.3-3.22-13.92-5C383.24,325.66,383.23,325.31,383.65,325.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.64,329.9a58.8,58.8,0,0,0,6.63.5c.05,0,.07.08,0,.09a13.81,13.81,0,0,1-6.69-.42C381.48,330,381.53,329.88,381.64,329.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.62,325.53a10.82,10.82,0,0,1,3.28,2.28c.11.1,0,.31-.17.21-.56-.4-1.13-.78-1.71-1.16a17.89,17.89,0,0,1-1.6-1C396.27,325.73,396.44,325.46,396.62,325.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.32,342c-.07.16.17.32.26.14h0a.29.29,0,0,0,.16.1,101.74,101.74,0,0,0,12.36,2.15c3.34.3,7.2.49,10.12-1.46,4-2.62,6.58-9.66,4.43-14.12-2.53-5.31-10.18-2.43-14-.54A28.17,28.17,0,0,0,432.32,342Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36,344.4a39.45,39.45,0,0,1,7.38-5.62,25.05,25.05,0,0,1,7.48-7.62c.14-.1.27.13.13.23a33.79,33.79,0,0,0-6.3,6.63,69.54,69.54,0,0,1,9.25-4.21,12.41,12.41,0,0,1,5-5c.05,0,.1,0,.06.07a20.05,20.05,0,0,0-4.49,4.71c1.88-.7,3.78-1.35,5.67-2,.18-.06.24.2.08.26-3.38,1.32-6.84,2.71-10.18,4.32a38.94,38.94,0,0,0,12.33,0c.11,0,.16.15,0,.18a24.31,24.31,0,0,1-13.08.19,61.55,61.55,0,0,0-6.2,3.48,15.51,15.51,0,0,1,5,.41,38.55,38.55,0,0,0,8.82,1,.1.1,0,0,1,0,.2c-5.11.88-9.94-1.45-15-.84a39,39,0,0,0-5.28,4.31,39.92,39.92,0,0,0-7.7,10.86c-2.13,4.34-3.29,8.94-5,13.43a.17.17,0,0,1-.32-.09C418.51,360.46,422.91,350.7,429.36,344.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.78,332.27a5.89,5.89,0,0,1,1.31-1.59,5.2,5.2,0,0,1,1.51-1.13s.08.05,0,.08c-.42.48-1,.83-1.46,1.28s-.83,1-1.29,1.45A.08.08,0,0,1,444.78,332.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.21,335c.76-.19,1.56-.17,2.33-.33a21.79,21.79,0,0,0,2.26-.68.09.09,0,0,1,.07.17,7.44,7.44,0,0,1-4.66,1.08C453.09,335.23,453.1,335,453.21,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.29 358.4 408.96 366.02 411.24 391.76 431.39 391.76 434.24 366.02 435.08 358.4 408.29 358.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.29 358.4 408.96 366.02 434.24 366.02 435.08 358.4 408.29 358.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.29,
    y: 356.32,
    width: 30.78,
    height: 6.18,
    transform: "translate(843.37 718.83) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesCuate);
export default __webpack_public_path__ + "static/media/Images-cuate.13fc6caab94b67c78e98213b59328c84.svg";
export { ForwardRef as ReactComponent };